export const getClassNames = (...classNames: Array<any>): string =>
  classNames.filter((c) => !!c).join(" ");
